import { EventParams } from '../interfaces';
import { log } from './messages';

type Params = Omit<EventParams, 'eventAction' | 'eventCategory'>;
type ParamsTuple<T> = T extends undefined ? [] : T extends Params ? [T] : never;

enum Event {
	FeedbackButtonClick = 'Clicked on rate us',
	SearchClick = 'Clicked on tracking button',
	HistoryClick = 'Click on package from history',
	EnterPackageId = 'Entered tracking id',
	EnterPackageName = 'Entered package name',
	ThemeChange = 'Changed theme'
}

interface ChangedThemeEventParams {
	eventLabel: 'dark' | 'bright';
}

function createEvent<T extends Params | undefined = undefined>(eventAction: Event, initialParams?: Params) {
	return (...params: ParamsTuple<T>) => {
		log({
			eventAction,
			...Object.assign({}, initialParams),
			...Object.assign({}, params as Params),
			eventCategory: 'Widget'
		});
	};
}

export const feedbackButtonClickEvent = createEvent(Event.FeedbackButtonClick);
export const searchClickEvent = createEvent(Event.SearchClick);
export const historyClickEvent = createEvent(Event.HistoryClick);
export const enterPackageIdEvent = createEvent(Event.EnterPackageId);
export const enterPackageNameEvent = createEvent(Event.EnterPackageName);
export const changedThemeEvent = createEvent<ChangedThemeEventParams>(Event.ThemeChange);
